import { apiUrl } from './tool'
import axios from 'axios'

const useMock = false

export function getDoctorInfoAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "doctor_code": "0UeuIW4r3E04",
        "doctor_name": "朱耕甫",
        "profile": "https://cdn.dentco.tw/doctor/images/profolio/5fc712d63df06.jpg",
        "birthday": "1992-03-23",
        "principle": "Fill the World with Beautiful Smiles",
        "qualification": "國防醫學院牙醫學士,前三軍總醫院牙醫師,台灣牙醫植體醫學會會員,Dent&Co Founder,",
        "education": [
          {
            "year": "2009,2015",
            "school": "國防醫學院",
            "partment": "牙醫學系"
          },
          {
            "year": "2018,至今",
            "school": "無",
            "partment": ""
          }
        ],
        "website": "https://www.facebook.com/%E7%9A%87%E5%AE%B6%E7%89%99%E9%86%AB%E8%A8%BA%E6%89%80-1051395404994928/",
        "fb_page": "https://www.facebook.com/companyfordentist/",
        "case_photo": [],
        "treatment": [
          {
            "description": "1",
            "sort": "99"
          },
          {
            "description": "2",
            "sort": "99"
          }
        ],
        "clinics": [
          {
            "clinic_code": "3731181091",
            "clinic_name": "皇家牙醫診所",
            "county": "新北市",
            "area": "深坑區",
            "address": "北深路3段26號",
            "tel": "(02)26629511"
          }
        ]
      }
    })
  }
  const url = apiUrl('doctor')
  return axios.get(url, {params})
}

export function updateDoctorInfoAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('doctor')
  return axios.post(url, data)
}

export function updateDoctorClinicAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('doctor', 'clinics')
  return axios.post(url, data)
}

export function uploadDoctorCaseAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('doctor', 'case_photo')
  return axios.post(url, data)
}

export function deleteDoctorCaseAPI(id, params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('doctor', 'case_photo', id)
  return axios.delete(url, {params})
}

export function createDoctorClinicAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('doctor', 'clinic')
  return axios.post(url, data)
}

export function deleteDoctorClinicAPI(clinicCode, params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('doctor', 'clinic', clinicCode)
  return axios.delete(url, {params})
}

export function settingSyncGoogleAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('doctor', 'calendar')
  return axios.post(url, data)
}

export function settingUnSyncGoogleAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('doctor', 'calendar')
  return axios.delete(url, {params})
}

export function syncGoogleAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('doctor', 'sync_calendar')
  return axios.post(url, data)
}

export function updateDoctorColorAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('doctor', 'color')
  return axios.post(url, data)
}

export function getDoctorQuestionActiveAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "question_active": 1
      }
    })
  }
  const url = apiUrl('doctor', 'question_active')
  return axios.get(url, {params})
}

export function updateDoctorQuestionActiveAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('doctor', 'question_active')
  return axios.put(url, data)
}

export function getDoctorVideosAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "shorts": [
          {
            "id": "8",
            "doctor_code": "cN46sm5E0TP3",
            "platform": "youtube-shorts",
            "type": "short",
            "url": "https://www.youtube.com/shorts/Z7sv6WD_prM",
            "created_at": "2025-06-22 08:18:42",
            "updated_at": null
          },
          {
            "id": "9",
            "doctor_code": "cN46sm5E0TP3",
            "platform": "youtube-shorts",
            "type": "short",
            "url": "https://www.youtube.com/shorts/WesUCGe3-ps",
            "created_at": "2025-06-22 08:18:42",
            "updated_at": null
          }
        ],
        "regular": [
          {
            "id": "10",
            "doctor_code": "cN46sm5E0TP3",
            "platform": "instagram-reels",
            "type": "regular",
            "url": "https://www.instagram.com/reels/DKWcksKNOI9/",
            "created_at": "2025-06-22 08:18:42",
            "updated_at": null
          }
        ]
      }
    })
  }
  const url = apiUrl('doctor', 'videos')
  return axios.get(url, {params})
}

export function saveDoctorVideosAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "success": true,
        "message": "影音資料已同步",
        "results": {
          "created": [16],
          "updated": [
            8,
            15,
            10
          ],
          "deleted": []
        }
      }
    })
  }
  const url = apiUrl('doctor', 'videos')
  return axios.post(url, data)
}

export function saveDoctorShortVideosAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "success": true,
        "message": "影音資料已同步",
        "results": {
          "created": [16],
          "updated": [
            8,
            15,
            10
          ],
          "deleted": []
        }
      }
    })
  }
  const url = apiUrl('doctor', 'videos', 'short')
  return axios.post(url, data)
}

export function saveDoctorRegularVideosAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "success": true,
        "message": "影音資料已同步",
        "results": {
          "created": [16],
          "updated": [
            8,
            15,
            10
          ],
          "deleted": []
        }
      }
    })
  }
  const url = apiUrl('doctor', 'videos', 'regular')
  return axios.post(url, data)
}

// ===== 診所衛教影音相關 API =====

